import { message } from "antd";
import axios from "axios";
import jsCookie from "js-cookie";
import { apiHeaders } from "../helper/apiHeader";
import { getStudentData } from "../helper/localStorage";
export const logoutApi = (dispatch, history) => {
  const { login_id } = getStudentData();
  const myData = {
    player_id: login_id,
  };

  axios
    .post("/MetaData", { data: myData }, apiHeaders("logout"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatch({ type: "RESET_LOGIN_DATA" })
        localStorage.clear();
        history.push("/");
      } else {
        message.error(res.data.msg);
      }
    })
    .catch((err) => {
      message.error("Please wait for sometime or check your internet connection. Try again");
    });
};
